export default __webpack_public_path__ + "static/media/bondrock-mv-rockwool-komposition_comp.19125535.jpg";